import type { FaireProductEntity } from "../../entity_types/product";

export const p_rzemzpvdgv: FaireProductEntity = {
  token: "p_rzemzpvdgv",
  type: "product",
  name: "Gold-plated stainless steel earrings",
  brandToken: "b_jbt25unvjp",
  brandName: "Gooddiy",
  imageUrl:
    "https://cdn.faire.com/fastly/b9ad76fdaec8a76dfe3b59669c3c87fac20da7b217a50693964a9b3c910e8233.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.82,
  description:
    "Wholesale 18K Gold Plated Geometric Shaped Stud Earrings Wholesale nhjie359248 Fashion Sun Disc Pendant Necklace Stainless Steel 1 Pair Style: Fashion Design: Plating Gender: Female Pattern: Geometric Material: Stainless Steel Occasion: Street Quantity: 1 Pair Classification: Earrings Weight: 15g",
  tags: [],
  msrpDollars: 3.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:01.307Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
